import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const BatchApprovalCard = ({ approval, onApprove, onReject }) => {
  const statusColors = {
    pending: 'bg-warning/10 text-warning border-warning',
    approved: 'bg-success/10 text-success border-success',
    rejected: 'bg-error/10 text-error border-error'
  };

  const statusIcons = {
    pending: 'Clock',
    approved: 'CheckCircle',
    rejected: 'XCircle'
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <h3 className="text-lg font-semibold text-foreground">
              Pay Period: {new Date(approval?.payrollRun?.payPeriodStart)?.toLocaleDateString()} - {new Date(approval?.payrollRun?.payPeriodEnd)?.toLocaleDateString()}
            </h3>
            <span className={`px-3 py-1 rounded-full text-xs font-medium border ${statusColors?.[approval?.approvalStatus]}`}>
              <Icon name={statusIcons?.[approval?.approvalStatus]} size={14} className="inline mr-1" />
              {approval?.approvalStatus?.toUpperCase()}
            </span>
          </div>
          <p className="text-sm text-muted-foreground">
            Submitted by {approval?.submittedBy} on {new Date(approval?.submittedAt)?.toLocaleString()}
          </p>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
        <div>
          <p className="text-xs text-muted-foreground mb-1">Total Employees</p>
          <p className="text-xl font-bold text-foreground">{approval?.totalEmployees}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Total Amount</p>
          <p className="text-xl font-bold text-success">K{approval?.totalAmount?.toLocaleString()}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Payment Date</p>
          <p className="text-sm font-medium text-foreground">
            {new Date(approval?.payrollRun?.paymentDate)?.toLocaleDateString()}
          </p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Departments</p>
          <p className="text-sm font-medium text-foreground">{approval?.departmentsIncluded?.length || 0}</p>
        </div>
      </div>
      {approval?.departmentsIncluded?.length > 0 && (
        <div className="mb-4">
          <p className="text-xs text-muted-foreground mb-2">Included Departments:</p>
          <div className="flex flex-wrap gap-2">
            {approval?.departmentsIncluded?.map((dept) => (
              <span key={dept} className="px-2 py-1 bg-primary/10 text-primary text-xs rounded">
                {dept}
              </span>
            ))}
          </div>
        </div>
      )}
      {approval?.approvalStatus === 'approved' && (
        <div className="bg-success/10 border border-success rounded-md p-3">
          <p className="text-sm text-success">
            <Icon name="CheckCircle" size={16} className="inline mr-2" />
            Approved by {approval?.approvedBy} on {new Date(approval?.approvedAt)?.toLocaleString()}
          </p>
        </div>
      )}
      {approval?.approvalStatus === 'rejected' && (
        <div className="bg-error/10 border border-error rounded-md p-3">
          <p className="text-sm text-error mb-1">
            <Icon name="XCircle" size={16} className="inline mr-2" />
            Rejected
          </p>
          {approval?.rejectionReason && (
            <p className="text-xs text-muted-foreground">Reason: {approval?.rejectionReason}</p>
          )}
        </div>
      )}
      {approval?.approvalStatus === 'pending' && (
        <div className="flex items-center gap-3 pt-4 border-t border-border">
          <Button
            variant="primary"
            size="sm"
            iconName="CheckCircle"
            onClick={() => onApprove(approval?.id)}
          >
            Approve
          </Button>
          <Button
            variant="outline"
            size="sm"
            iconName="XCircle"
            onClick={() => onReject(approval?.id)}
          >
            Reject
          </Button>
        </div>
      )}
    </div>
  );
};

export default BatchApprovalCard;